import { apiRequest } from './apiClient.js';

export const pushInboxService = {
    clearRead: () => apiRequest('/push/read', { method: 'DELETE' }),
    history: (section, before) => apiRequest(`/push/inbox?section=${encodeURIComponent(section)}&status=read${before ? `&before=${encodeURIComponent(before)}` : ''}`, { cache: 'no-store', responseContract: 'push_inbox_response' }),
    inbox: (section, id) => apiRequest(`/push/inbox?section=${encodeURIComponent(section)}${id ? `&id=${encodeURIComponent(id)}` : ''}`, { cache: 'no-store', responseContract: 'push_inbox_response' }),
    read: (ids) => apiRequest('/push/read', { method: 'POST', body: JSON.stringify({ ids }) }),
    register: (device) => apiRequest('/push/devices', { method: 'POST', body: JSON.stringify(device) }),
    unregister: (device) => apiRequest('/push/devices', { method: 'DELETE', body: JSON.stringify(device), identityChange: true })
};
